import { render, staticRenderFns } from "./tableFaqAccommodation.vue?vue&type=template&id=70abf4b2&scoped=true"
import script from "./tableFaqAccommodation.vue?vue&type=script&lang=js"
export * from "./tableFaqAccommodation.vue?vue&type=script&lang=js"
import style0 from "./tableFaqAccommodation.vue?vue&type=style&index=0&id=70abf4b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70abf4b2",
  null
  
)

export default component.exports